module.exports = "<div id=\"breadcrumbs\" class=\"breadcrumbs\">\n\t<ul class=\"breadcrumb\">\n\t\t<li><i class=\"ace-icon fa fa-home home-icon\"></i></li>\n\t\t<li *ngFor=\"let route of routes; let i = index\" [ngClass]=\"{'active': i == routes.length-1}\">\n\t\t\t{{route}}\n\t\t</li>\n\t</ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/breadcrumbs/breadcrumbs.html
// module id = 526
// module chunks = 0